




import { Component, Mixins, Prop } from "vue-property-decorator";
import {
  Document,
  DocumentParameterContainer,
  DocumentRegistrationResult,
  IDocumentRegistrationResultRegisteredDetail
} from "../../../domain/document";
import { SystemLogger } from "../../../domain/system";
import { DocumentEditViewMixin } from "../mixins";
import { default as DocumentProcessor } from "./DocumentProcessor.vue";

@Component({
  components: {
    DocumentProcessor,
  },
})
export default class NewDocumentsProcessor extends Mixins(DocumentEditViewMixin) {
  @Prop()
  process: (source: Document) => Promise<number>;

  @Prop()
  emptyHisKeys: string[];

  @Prop()
  chainedFormatIds: number[];

  $refs!: {
    processor: DocumentProcessor,
  };

  async processDocuments(formatIds: number[], intervalMilliSeconds: number, institutionNo: string, regionalInstitutionNo: string, hisInfoGetterParameter: string, orderNo: string, systemKey: string, linkKey: string, parameterContainer: DocumentParameterContainer): Promise<DocumentRegistrationResult[]> {
    this._validateLinkKey(formatIds, linkKey);
    return this._processDocuments(
      formatIds,
      intervalMilliSeconds,
      async i => this.$refs.processor.processDocument((this.chainedFormatIds && this.chainedFormatIds.length > 0)
        ? await this.createNewInitializedChainDocument(this.patientNo, i, this.chainedFormatIds, institutionNo, regionalInstitutionNo, hisInfoGetterParameter, orderNo, systemKey, linkKey, parameterContainer)
        : await this.createNewInitializedDocument(this.patientNo, i, institutionNo, regionalInstitutionNo, hisInfoGetterParameter, orderNo, systemKey, linkKey, parameterContainer)));
  }

  private _validateLinkKey(formatIds: number[], linkKey: string): void {
    if (linkKey && (1 < formatIds.length)) {
      throw new Error("オーダとのリンクが指定されてるのに" + this.$wording.format.name + "IDが複数指定されています.");
    }
  }

  private async _processDocuments(formatIds: number[], intervalMilliSeconds: number, processDocument: (formatId: number) => Promise<DocumentRegistrationResult>): Promise<DocumentRegistrationResult[]> {
    if (!formatIds) {
      throw new Error(this.$wording.format.name + "IDが指定されていません.指定してください.");
    }
    this.$logger.info("新規文書を処理します.(" + formatIds.length + "文書)");
    let count = 0;
    const result: DocumentRegistrationResult[] = [];
    let isFirst = true;
    for (const formatId of formatIds) {
      if (!isFirst && intervalMilliSeconds > 0) {
        await this.$sleep(intervalMilliSeconds);
      }
      try {
        await this.validateSingleEntry(this.patientNo, formatId, false);
        const registrationResult = await processDocument(formatId);
        const documentId = (registrationResult.detail as IDocumentRegistrationResultRegisteredDetail).id;
        count++;
        result.push(registrationResult);
        this.$logger.info("新規文書(" + this.$wording.format.name + "ID:" + formatId + "を処理しました.(文書ID:" + documentId + ")");
      } catch (e) {
        this.$logger.error(e.message);
        this.$logger.error("新規文書処理中に問題が発生しました.当該文書の処理をスキップします.");
        await SystemLogger.error("新規文書処理中に問題が発生しました.", e, this.patientNo);
      }
      isFirst = false;
    }
    this.$logger.info("新規文書を処理しました.(" + count + "文書)");
    return result;
  }
}
